import { Action } from 'redux'
import { ProvenancesActions } from '../../reducers/provenances/actionNames'

const toggleProvenancesModal = (toggle = false): IToggleProvenancesModal => ({
  toggle,
  type: ProvenancesActions.ToggleProvenancesModal,
})

export { toggleProvenancesModal }

export interface IToggleProvenancesModal
  extends Action<ProvenancesActions.ToggleProvenancesModal> {
  toggle?: boolean
}
